export default __webpack_public_path__ + "static/media/Beehaz_04_invoices.ed6021a0.png";